import HomeScrollPicFragment from "../../components/dashboard/HomeScrollPicFragment";
import HomeScrollQuizFragment from "../../components/dashboard/HomeScrollQuizFragment";
import HomeTextFragment from "../../components/dashboard/HomeTextFragment";
import HomeScrollVidFragment from "../../components/dashboard/HomeScrollVidFragment";
import PrimaryButton from "../../components/PrimaryButton";
import { useEffect, useRef, useState } from "react";
import UserFeedard from "../../components/dashboard/UserFeedCard";
import { useLocation, useNavigate } from "react-router-dom";
import { AppPaths } from "../../utils/AppPaths";
import EmojiModal from "../../components/dashboard/EmojiModal";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import DiamondIcon from "../../assets/diamond.png";
import unicornImg from "../../assets/unicorn.svg";
import CrackerImg from "../../assets/Crackers.png";
import WelcomeImg from "../../assets/welcome.gif";
import CompletedImg from "../../assets/completed_challenge.png";
import Feeds from "../../components/dashboard/Feeds";
import LeaderboardModal from "../../components/dashboard/LeaderboardModal";
import CoachMarkStepOne from "../../components/dashboard/CoachMarkStepOne";
import CoachMarkStepTwo from "../../components/dashboard/CoachMarkStepTwo";
import CoachMarkStepThree from "../../components/dashboard/CoachMarkStepThree";
import CoachMarkStepFour from "../../components/dashboard/CoachMarkStepFour";
import CoachMarkStepFive from "../../components/dashboard/CoachMarkStepFive";
import CoachMarkStepSix from "../../components/dashboard/CoachMarkStepSix";
import CoachMarkStepSeven from "../../components/dashboard/CoachMarkStepSeven";
import CoachMarkStepEight from "../../components/dashboard/CoachMarkStepEight";
import CoachMarkStepNine from "../../components/dashboard/CoachMarkStepNine";

import {
  setActiveTab,
  setEmojiModal,
  setPointData,
  setPointsTracker,
  setUserData,
} from "../../redux/rootSlice";
import PointsTrackerModal from "../../components/PointsTrackerModal";
import { setSelctedImoji } from "../../redux/homeScreenSlice";
import LoadImage from "../../assets/loader.gif";
import {
  AnxiousImages,
  InBetweenImage,
  difficultImage,
  getColor,
  getImageType,
  getImageUrl,
  happyImages,
} from "../../constants/reactionImages";
import ApiService from "../../api/ApiServices";
import { Modal } from "../../components/Unicorn";
import moment from "moment";
import { convertTo24Hour } from "../../utils/utils";
import { isMobile } from "react-device-detect";
import AlertModal from "../../components/AlertModal";


const HomeScreen = () => {
  const [bedTime, setBedTime] = useState("");
  const [wokeUpTime, setWokeUpTime] = useState("");
  const [submit, setSubmit] = useState(false);
  const [userDetails, setUserDetails] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>(null);
  const [load, setLoad] = useState<boolean>(false);
  const [challengeLoad, setChallengeLoad] = useState<boolean>(false);
  const [alreadyCheckIn, setAlreadyCheckIn] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [feeds, setFeeds] = useState<any>();
  const [checkInPoints, setCheckInPoints] = useState<any>();
  const [housePoints, setHousePoints] = useState<any>();
  const [headerStats, setHeaderStats] = useState({ home: 0, stars: 0, fire: 0 });
  const [leaderboardModalOpen, setLeaderboardModalOpen] = useState(false);
  const [leaderboardLoading, setLeaderboardLoading] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState<any>(null);
  const leaderboardAutoOpenedRef = useRef(false);
  const [availableChallengeIds, setAvailableChallengeIds] = useState<Set<string>>(new Set());
  const { emojiModal } = useAppSelector((state) => state.root);
  const emojiRef = useRef<HTMLDivElement | null>(null);
  const { selectedImoji, recentUsedImoji } = useAppSelector(
    (state) => state.home
  );
  const [info, setInfo] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const [readMoreModal, setReadMoreModal] = useState(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [coachMarkStep, setCoachMarkStep] = useState<0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9>(0);

  const openAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const handleReadMore = (data: any) => {
    setInfo(data);
    setReadMoreModal(!readMoreModal);
  };
  const handleClose = () => {
    setIsOpen(false);
    navigate(AppPaths.HOME);
  };
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setActiveTab(2));
  }, [dispatch]);
  useEffect(() => {
    dispatch(setSelctedImoji(Object.entries(AnxiousImages)[0]));
    dispatch(setSelctedImoji(Object.entries(difficultImage)[7]));
    dispatch(setSelctedImoji(Object.entries(InBetweenImage)[1]));
    dispatch(setSelctedImoji(Object.entries(happyImages)[0]));
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    if ((location.state as { openChallengeModal?: boolean } | null)?.openChallengeModal) {
      setIsOpen(true);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.pathname, location.state, navigate]);

  const handleBedTimeChange = (e: any) => {
    setBedTime(e.target.value);
  };
  const handleWokeUpChange = (e: any) => {
    setWokeUpTime(e.target.value);
  };

  const handleSubmit = async () => {
    if (wokeUpTime !== bedTime) {
      const response = await ApiService.dailyCheckIn({
        bedTime: bedTime,
        wakeupTime: wokeUpTime,
        todayFeeling: selectedImoji?.[0],
        date: moment().format("YYYY-MM-DD"),
        emojiType: selectedImoji
          ? getImageType(selectedImoji[0].toString())
          : null,
      }).then((data) => {
        if (data?.status) {
          setResponseData(data?.data);
          setCheckInPoints(checkInPoints + 5);
        }
      });
    } else {
      openAlert("Please check bed time and woke up time");
    }
  };

  const editSubmit = async () => {
    if (wokeUpTime !== bedTime) {
      const response = await ApiService.editDailyCheckIn({
        bedTime: bedTime,
        wakeupTime: wokeUpTime,
        todayFeeling: selectedImoji?.[0],
        date: moment().format("YYYY-MM-DD"),
        emojiType: selectedImoji
          ? getImageType(selectedImoji[0].toString())
          : null,
      }).then((data) => {
        if (data?.status) {
          setResponseData(data?.data);
          setEdit(true);
        }
      });
    } else {
      openAlert("Please check bed time and woke up time");
    }
  };

  useEffect(() => {
    if (responseData) {
      setSubmit(true);
    }
  }, [responseData]);

  useEffect(() => {
    if (emojiRef.current) {
      emojiRef.current.scrollLeft = 0;
    }
  }, [selectedImoji]);

  useEffect(() => {
    if (userDetails) {
      if (userDetails?.user?.userCheckin) {
        setSubmit(true);
        setResponseData(userDetails?.usercheckInData);
        const bedTimeValue = userDetails?.usercheckInData?.bedTime;
        const wakeupTimeValue = userDetails?.usercheckInData?.wakeupTime;

        if (bedTimeValue) {
          setBedTime(convertTo24Hour(bedTimeValue));
        }
        if (wakeupTimeValue) {
          setWokeUpTime(convertTo24Hour(wakeupTimeValue));
        }
        setAlreadyCheckIn(true);
      }
    }
  }, [userDetails]);

  const getFeedData = async () => {
    setLoad(true);
    const [response, responseUser, pointsResponse, availableResponse] = await Promise.all([
      ApiService.getProfile(),
      ApiService.getUserProfile(),
      ApiService.getPoints(),
      ApiService.getAvailableChallenges(),
    ]);

    const pointsData = pointsResponse?.data || {};
    setHeaderStats({
      home: Number(pointsData?.totalHousePoints) || 0,
      stars: Number(pointsData?.availablePoints) || 0,
      fire: Number(pointsData?.totalStreakPoints) || 0,
    });

    const availableSource = Array.isArray(availableResponse?.data) ? availableResponse.data : [];
    const nextAvailableIds = new Set<string>(
      availableSource
        .map((item: any) => String(item?._id || item?.challengeId?._id || item?.challengeId || ""))
        .filter((challengeId: string) => Boolean(challengeId))
    );
    setAvailableChallengeIds(nextAvailableIds);
    
    // Merge user data from getUserProfile into userDetails
    setUserDetails({
      user: responseUser?.data?.user,
      house: responseUser?.data?.house,
      usercheckInData: responseUser?.data?.usercheckInData,
      challenges: response?.data?.challenges,
      houseMatches: response?.data?.houseMatches || [],
    });
    
    setHousePoints(response?.data?.challengePoints);
    setFeeds(response?.data?.attemptChallenges);
    setCheckInPoints(response?.data?.checkInPoints);
    
    dispatch(setUserData(responseUser?.data?.user));
    dispatch(
      setPointData({
        challengePoints: response?.data?.challengePoints,
        checkInPoints: response?.data?.checkInPoints,
      })
    );
    localStorage.setItem("userId", responseUser?.data?.user?._id);
    setLoad(false);
  };

  useEffect(() => {
    if (userDetails === null) {
      getFeedData();
    }
  }, []);

const Header = ({ name = "User", stats = { home: 0, stars: 0, fire: 0 } }) => {
  return (
    <div className="container">
      <header className="header-banner">
        <svg width="0" height="0">
          <defs>
            <clipPath id="concaveCurve" clipPathUnits="objectBoundingBox">
              {/* This path draws a box and then arcs INWARD at the bottom */}
              {/* <path d="M0,0 H1 V0.8 Q0.5,0.6 0,0.8 Z" /> */}
              <path d="M0,0 H1 V1 Q0.5,0.2 0,1 Z" />
              {/* <path d="M0,0 H1 V1 C0.75,0.2 0.25,0.2 0,1 Z" /> */}
            </clipPath>
          </defs>
        </svg>

        <div className="grid w-full grid-cols-2 items-start">
          <div className="logo justify-self-start">
            <img src={require("../../assets/u4u_logo.png")} alt="U4u Logo" className="header-u4u" />
          </div>

          <div className="stats-container justify-self-end">
            <div className={`stat-bubble cursor-pointer coach-view-house ${
              coachMarkStep === 5 ? "coach-view-house-highlight" : ""
            }`} onClick={() => {
                openLeaderboardModal();
              }}>
              <span><img src={require("../../assets/house.png")} alt="" className="w-4 h-4" /></span> {stats.home}
            </div>
            <div
              className={`stat-bubble cursor-pointer coach-view-prize ${
                coachMarkStep === 4 ? "coach-view-prize-highlight" : ""
              }`} onClick={() => {
                            navigate(AppPaths.PRIZES);
                          }}
            >
              <span><img src={require("../../assets/star.png")} alt="" className="w-5 h-5" /></span> {stats.stars}
            </div>
            <div className="stat-bubble">
              <span><img src={require("../../assets/fire.png")} alt="" className="w-4 h-4" /></span> {stats.fire}
            </div>
          </div>
        </div>
      </header>

      {/* Text below the curve */}
      <div className="welcome-text">Welcome {name}!</div>
    </div>
  );
};



  const renderCheckInSaved = () => {
    return (
      <>
        {((responseData && Object.keys(responseData).length > 0) ||
          alreadyCheckIn) && (
            <div
              className="flex flex-row flex-1 mx-3 home-frag-checkin"
              style={{ backgroundColor: "#FAEDF9" }}
            >
              <div className="flex flex-col items-center flex-1 py-1 dailt-check-box-filled ">
                <div className="sub-title-text-16">I’m feeling...</div>
                <img
                  alt=""
                  className="emoji-l"
                  src={getImageUrl(responseData?.todayFeeling)}
                />
                <div className="onb1-text">{responseData?.todayFeeling}</div>
              </div>
              <div className="flex flex-col items-center flex-1 py-1">
                <div className="sub-title-text-16">I slept...</div>
                <div className="flex flex-row items-baseline">
                  <div className="input-text-44-bold">
                    {responseData?.timeDiff?.hours}
                  </div>
                  <div className="inline-block input-text-12-bold">HRS</div>
                </div>
                <div className="inter-regular-12">
                  {responseData?.bedTime} - {responseData?.wakeupTime}
                </div>
              </div>
            </div>
          )}
      </>
    );
  };

  // const renderCheckInCard = () => {
  //   return (
  //     <div className="py-3 mx-3 home-frag-checkin">
  //       <div className="ml-3 inter-20-semi-bold">Daily Check-in</div>
        
  //           <div className="flex flex-row items-center text-center inter-text-14-semibold rating">
  //             <img
  //               src={require("../../assets/header_star.png")}
  //               alt=""
  //               className="w-5 h-5 mr-1"
  //             />
  //             5 pts
  //           </div>
  //       <div className="mx-3 inter-16-regular">How are you feeling?</div>

  //       <div className="flex flex-row py-2 ml-3 overflow-x-auto" ref={emojiRef}>
  //         <div className="grid grid-flow-col grid-rows-1 gap-1">
  //           {recentUsedImoji
  //             ?.slice()
  //             ?.reverse()
  //             ?.map((img: any) => (
  //               <div
  //                 onClick={() => {
  //                   dispatch(setSelctedImoji(img));
  //                 }}
  //                 className={`emoji-cont emoji-cont-width flex flex-col items-center ${selectedImoji?.[0] === img?.[0] && "emoji-selected"
  //                   } `}
  //                 style={{
  //                   backgroundColor: selectedImoji
  //                     ? getColor(img?.[0])
  //                     : undefined,
  //                 }}
  //               >
  //                 <img src={img?.[1]} alt="" className="emoji" />
  //                 <div
  //                   className="flex flex-row flex-wrap items-center pt-2 text-center inter-text-9-semibold"
  //                 // style={{ whiteSpace: "pre-wrap", width: 50 }}
  //                 >
  //                   {img?.[0]}
  //                 </div>
  //               </div>
  //             ))}
  //           <div
  //             onClick={() => {
  //               dispatch(setEmojiModal(true));
  //               // navigate(AppPaths.EMOJI_MODAL);
  //             }}
  //             className="flex flex-col items-center emoji-cont emoji-cont-width"
  //           >
  //             <div className="flex items-center flex-1 ">
  //               <img
  //                 src={require("../../assets/plus.png")}
  //                 alt=""
  //                 className="my-2 add"
  //               />
  //             </div>
  //             <div className="flex flex-row flex-wrap items-center text-center inter-text-9-semibold ">
  //               See More
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="flex flex-row flex-1 mx-3 my-3 ">
  //         <div className="flex flex-row items-center justify-between flex-1 mr-4 ">
  //           <div className="flex flex-1 mr-2 text-center inter-regular-14">
  //             I went to bed at...
  //           </div>
  //           {false ? (
  //             <img
  //               alt=""
  //               src={require("../../assets/moon_empty.png")}
  //               className="daily-check-time-icon-2"
  //             />
  //           ) : (
  //             <img
  //               alt=""
  //               src={require("../../assets/sleep_filled.png")}
  //               className="daily-check-time-icon"
  //             />
  //           )}
  //         </div>
  //         <div className="flex flex-row items-center justify-between flex-1">
  //           <div className="mr-2 text-center inter-regular-14 ">
  //             I woke up at...
  //           </div>
  //           {false ? (
  //             <img
  //               alt=""
  //               src={require("../../assets/sun_empty.png")}
  //               className="daily-check-time-icon"
  //             />
  //           ) : (
  //             <img
  //               alt=""
  //               src={require("../../assets/sun-filles.png")}
  //               className="daily-check-time-icon"
  //             />
  //           )}
  //         </div>
  //       </div>
  //       <div className="flex flex-row flex-1 mx-3 mb-3">
  //         {/* <TextInput
  //           placeholder="--:--"
  //           value={bedTime}
  //           textStyle={"text-center"}
  //           onChange={handleBedTimeChange}
  //           containerStyles="px-3 py-2 mr-3"
  //           textInputStyles={{ maxWidth: "100%" }}
  //         /> */}
  //         <div className="flex flex-row flex-1 px-3 py-2 TextInput relative mr-3">
  //           <input
  //             type="time"
  //             className={`w-full flex justify-center text-center outline-none inter-regular-16 ${!bedTime ? "font-white" : "font-black"
  //               }`}
  //             style={{
  //               backgroundColor: "#ffffff",
  //             }}
  //             value={bedTime}
  //             onChange={handleBedTimeChange}
  //             min="09:00"
  //             max="12:00"
  //           />
  //           {!bedTime ? (
  //             <span
  //               style={{
  //                 display: "flex",
  //                 pointerEvents: "none",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 alignSelf: "center",
  //                 position: "absolute",
  //                 top: "50%",
  //                 left: "50%",
  //                 transform: "translate(-50%, -50%)",
  //                 fontFamily: "Inter-Regular",
  //                 fontSize: "24px",
  //                 width: "100%",
  //                 backgroundColor: "white",
  //               }}
  //             >
  //               --:--
  //             </span>
  //           ) : (
  //             <span
  //               style={{
  //                 display: "flex",
  //                 pointerEvents: "none",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 alignSelf: "center",
  //                 position: "absolute",
  //                 top: "50%",
  //                 left: "50%",
  //                 transform: "translate(-50%, -50%)",
  //                 width: "100%",
  //                 backgroundColor: "white",
  //                 fontFamily: "Inter-Bold",
  //                 fontSize: "17px",
  //                 color: "black",
  //               }}
  //             >
  //               {moment(bedTime, "HH:mm").format("h:mm A")}
  //             </span>
  //           )}
  //         </div>

  //         <div className="flex flex-row flex-1 px-3 py-2 TextInput relative mr-3">
  //           <input
  //             type="time"
  //             className={`w-full flex justify-center text-center outline-none inter-regular-16 ${!wokeUpTime ? "font-white" : "font-black"
  //               }`}
  //             style={{
  //               backgroundColor: "#ffffff",
  //             }}
  //             value={wokeUpTime}
  //             onChange={handleWokeUpChange}
  //             min="09:00"
  //             max="12:00"
  //           />
  //           {!wokeUpTime ? (
  //             <span
  //               style={{
  //                 display: "flex",
  //                 pointerEvents: "none",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 alignSelf: "center",
  //                 position: "absolute",
  //                 top: "50%",
  //                 left: "50%",
  //                 transform: "translate(-50%, -50%)",
  //                 fontFamily: "Inter-Regular",
  //                 fontSize: "24px",
  //                 width: "100%",
  //                 backgroundColor: "white",
  //               }}
  //             >
  //               --:--
  //             </span>
  //           ) : (
  //             <span
  //               style={{
  //                 display: "flex",
  //                 pointerEvents: "none",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 alignSelf: "center",
  //                 position: "absolute",
  //                 top: "50%",
  //                 left: "50%",
  //                 transform: "translate(-50%, -50%)",
  //                 width: "100%",
  //                 backgroundColor: "white",
  //                 fontFamily: "Inter-Bold",
  //                 fontSize: "17px",
  //                 color: "black",
  //               }}
  //             >
  //               {moment(wokeUpTime, "HH:mm").format("h:mm A")}
  //             </span>
  //           )}
  //         </div>
  //       </div>
  //       <PrimaryButton
  //         text="SUBMIT"
  //         onClick={() => {
  //           // setSubmit(true);
  //           if (userDetails?.user?.userCheckin) {
  //             editSubmit();
  //           } else {
  //             handleSubmit();
  //           }
  //         }}
  //         containerStyles="px-1 py-1 mx-3 "
  //         textStyle="inter-12-bold"
  //       />
  //     </div>
  //   );
  // };

  const renderCheckInCard = () => {
  return (
    <div className="p-4 mx-3 bg-white home-frag-checkin py-1">
      {/* Header Row */}
      <div className="flex items-center justify-between mb-1">
        <div className="inter-20-semi-bold">Daily Check-in</div>
        <div className="flex checkin-points">
          <img src={require("../../assets/star.png")} alt="" className="w-4 h-4" />
          +5pts
        </div>
      </div>

      <div className="text-base font-medium">How are you feeling?</div>

      {/* Emoji Row */}
      <div className="flex flex-row py-1 overflow-x-auto gap-2" style={{paddingLeft: "2px"}} ref={emojiRef}>
        {recentUsedImoji?.slice().reverse().map((img) => (
          <div
            key={img[0]}
            onClick={() => dispatch(setSelctedImoji(img))}
            className={`flex flex-col items-center p-1 rounded-lg w-16 min-w-[52px] ${
              selectedImoji?.[0] === img?.[0] ? "ring-2 ring-blue-400" : ""
            }`}
            style={{ backgroundColor: getColor(img[0]) }}
          >
            <img src={img[1]} alt="" className="w-7 h-7 mb-1" />
            <div className="text-[10px] font-bold text-center">{img[0]}</div>
          </div>
        ))}
        {/* See More Button */}
        <div 
          onClick={() => dispatch(setEmojiModal(true))}
          className="flex flex-col items-center justify-center p-2 rounded-lg w-16 min-w-[64px] bg-purple-100"
        >
          <img src={require("../../assets/plus.png")} alt="" className="w-4 h-4 mb-1" />
          <div className="text-[10px] font-bold">See More</div>
        </div>
      </div>

      {/* Time Selection Row */}
      <div className="flex flex-row gap-4 mb-2">
        {/* Bedtime Input */}
        <div className="flex-1">
          <div className="inter-16-regular mb-1">I went to bed at</div>
          <div className="relative flex items-center p-2 border border-black rounded-lg" style={{ height: '35px' }}>
             <input 
                type="time" 
                className="font-bold outline-none" 
                value={bedTime} 
                onChange={handleBedTimeChange} 
             />
             {bedTime && (
               <span className="ml-2 text-sm font-semibold whitespace-nowrap">
                 {moment(bedTime, "HH:mm").format("h:mm A")}
               </span>
             )}
             <span className="ml-auto"><img src={require("../../assets/sleepMoon.png")} alt="" className="w-5 h-5" /></span>
          </div>
        </div>

        {/* Wake up Input */}
        <div className="flex-1">
          <div className="inter-16-regular mb-1">I woke up at</div>
          <div className="relative flex items-center p-2 border border-black rounded-lg" style={{ height: '35px' }}>
             <input 
                type="time" 
                className=" font-bold outline-none" 
                value={wokeUpTime} 
                onChange={handleWokeUpChange} 
             />
             {wokeUpTime && (
               <span className="ml-2 text-sm font-semibold whitespace-nowrap">
                 {moment(wokeUpTime, "HH:mm").format("h:mm A")}
               </span>
             )}
             <span className="ml-auto"><img src={require("../../assets/sun.png")} alt="" className="w-5 h-5" /></span>
          </div>
        </div>
      </div>

      {/* Action Button */}
      <div className="text-center mb-2">
        <button
          onClick={userDetails?.user?.userCheckin ? editSubmit : handleSubmit}
          className="checkin-button text-white"
        >
          COMPLETE CHECK-IN
        </button>
      </div>
      
    </div>
  );
};

  const getChallengeList = async () => {
    setChallengeLoad(true);
    const [response, availableResponse] = await Promise.all([
      ApiService.getChallenges(),
      ApiService.getAvailableChallenges(),
    ]);
    setUserDetails({ ...userDetails, challenges: response?.data });

    const availableSource = Array.isArray(availableResponse?.data) ? availableResponse.data : [];
    const nextAvailableIds = new Set<string>(
      availableSource
        .map((item: any) => String(item?._id || item?.challengeId?._id || item?.challengeId || ""))
        .filter((challengeId: string) => Boolean(challengeId))
    );
    setAvailableChallengeIds(nextAvailableIds);

    setTimeout(() => {
      setChallengeLoad(false);
    }, 3000);
  };

  const getFeeds = async () => {
    const response = await ApiService.getFeeds();
    setFeeds(response?.data)
  }

  const isWithinPostEndDateWindow = (endDateValue?: string) => {
    if (!endDateValue) return false;

    const endDateMoment = moment(endDateValue).startOf("day");
    if (!endDateMoment.isValid()) return false;

    const startWindow = endDateMoment.clone().add(1, "day");
    const endWindow = endDateMoment.clone().add(7, "day").endOf("day");
    const now = moment();

    return now.isBetween(startWindow, endWindow, undefined, "[]");
  };

  const openLeaderboardModal = async (options?: { auto?: boolean }) => {
    const isAutoOpen = Boolean(options?.auto);
    if (!isAutoOpen) {
      setLeaderboardModalOpen(true);
    }

    setLeaderboardLoading(true);

    try {
      const response = await ApiService.getLeaderboard();
      if (response?.status) {
        const firstLeaderboard = Array.isArray(response?.data)
          ? response.data[0] || null
          : null;
        setLeaderboardData(firstLeaderboard);

        if (isAutoOpen) {
          const competition = firstLeaderboard?.competition || {};
          const endDateValue = competition?.endDate || competition?.end_date;
          if (isWithinPostEndDateWindow(endDateValue)) {
            setLeaderboardModalOpen(true);
          }
        }
      } else {
        setLeaderboardData(null);
      }
    } catch (error) {
      setLeaderboardData(null);
      openAlert("Failed to load leaderboard");
    } finally {
      setLeaderboardLoading(false);
    }
  };

  useEffect(() => {
    if (leaderboardAutoOpenedRef.current) return;
    leaderboardAutoOpenedRef.current = true;
    openLeaderboardModal({ auto: true });
  }, []);

  useEffect(() => {
    if (!userDetails?.user) return;

    if (!userDetails.user.houseId) {
      setCoachMarkStep(0);
      return;
    }

    if (userDetails.user.coachMarkStatus) {
      setCoachMarkStep(0);
      return;
    }

    setCoachMarkStep((currentStep) => (currentStep === 0 ? 1 : currentStep));
  }, [userDetails]);

  const onCoachMarkPlay = () => {
    setCoachMarkStep(2);
  };

  const onCoachMarkNext = () => {
    setCoachMarkStep(3);
  };

  const onCoachMarkStepThreeNext = () => {
    setCoachMarkStep(4);
  };

  const onCoachMarkStepFourNext = () => {
    setCoachMarkStep(5);
  };

  const onCoachMarkStepFiveNext = () => {
    setCoachMarkStep(6);
  };

  const onCoachMarkStepSixNext = () => {
    setCoachMarkStep(7);
  };

  const onCoachMarkStepSevenNext = () => {
    setCoachMarkStep(8);
  };

  const onCoachMarkStepEightNext = () => {
    setCoachMarkStep(9);
  };

  const onCoachMarkStepNineNext = async () => {
    try {
      const response = await ApiService.updateUserDetails({ coachMarkStatus: true });
      const updatedUser = response?.data?.user || response?.data || null;

      setUserDetails((prev: any) => {
        if (!prev?.user) return prev;

        return {
          ...prev,
          user: {
            ...prev.user,
            ...(updatedUser || {}),
            coachMarkStatus: true,
          },
        };
      });

      dispatch(
        setUserData({
          ...(userDetails?.user || {}),
          ...(updatedUser || {}),
          coachMarkStatus: true,
        })
      );

      setCoachMarkStep(0);
    } catch (error) {
      openAlert("Unable to save coach mark progress. Please try again.");
    }
  };
  const handleSuccess = async () => {
    getChallengeList();

    const [profileResponse, pointsResponse] = await Promise.all([
      ApiService.getProfile(),
      ApiService.getPoints(),
    ]);

    const pointsData = pointsResponse?.data || {};
    setHeaderStats({
      home: Number(pointsData?.totalHousePoints) || 0,
      stars: Number(pointsData?.availablePoints) || 0,
      fire: Number(pointsData?.totalStreakPoints) || 0,
    });

    setUserDetails((prev: any) => ({
      ...prev,
      challenges: profileResponse?.data?.challenges,
      houseMatches: profileResponse?.data?.houseMatches || [],
    }));

    setHousePoints(pointsData?.totalHousePoints ?? housePoints);
    setCheckInPoints(pointsData?.availablePoints ?? checkInPoints);

    setHousePoints(profileResponse?.data?.challengePoints);
    setFeeds(profileResponse?.data?.attemptChallenges);
    setCheckInPoints(profileResponse?.data?.checkInPoints);
    dispatch(
      setPointData({
        challengePoints: pointsData?.totalHousePoints,
        checkInPoints: pointsData?.availablePoints,
      })
    );
  };

  const RenderChallenges = ({
    challenge,
    index,
  }: {
    challenge: any;
    index: number;
  }) => {
    const challengeId = String(challenge?._id || "");
    const isChallengeCompleted = challengeId ? !availableChallengeIds.has(challengeId) : false;
    const highlightClass = coachMarkStep === 3 && index === 0 ? "home-frag-cont-highlight" : "";

    if (challenge?.type === "text") {
      return (
        <HomeTextFragment
          key={challenge?._id}
          id={challenge?._id}
          picUrl={challenge?.url}
          contStyle={highlightClass}
          handleSuccess={handleSuccess}
          handleReadMore={handleReadMore}
          data={challenge}
          isChallengeCompleted={isChallengeCompleted}
        />
      );
    } else if (challenge?.type === "video") {
      return (
        <HomeScrollVidFragment
          key={challenge?._id}
          id={challenge?._id}
          picUrl={challenge?.url}
          contStyle={highlightClass}
          handleSuccess={handleSuccess}
          handleReadMore={handleReadMore}
          data={challenge}
          thumbnail={challenge?.metadata?.thumbnail}
          skipAvailabilityCheck
          isChallengeCompleted={isChallengeCompleted}
        />
      );
    } else if (challenge?.type === "image") {
      return (
        <HomeScrollPicFragment
          key={challenge?._id}
          id={challenge?._id}
          picUrl={challenge?.url}
          contStyle={highlightClass}
          handleSuccess={handleSuccess}
          handleReadMore={handleReadMore}
          data={challenge}
          skipAvailabilityCheck
          isChallengeCompleted={isChallengeCompleted}
        />
      );
    }
    return (
      <HomeScrollQuizFragment
        key={challenge?._id}
        id={challenge?._id}
        picUrl={challenge?.metadata?.thumbnail}
        contStyle={highlightClass}
        handleReadMore={handleReadMore}
        data={challenge}
        skipAvailabilityCheck
        isChallengeCompleted={isChallengeCompleted}
      />
    );
  };

  return (
    <>
      <CoachMarkStepOne
        visible={coachMarkStep === 1}
        userName={userDetails?.user?.name || "there"}
        onPlay={onCoachMarkPlay}
      />
      <CoachMarkStepTwo
        visible={coachMarkStep === 2}
        // houseName={userDetails?.house?.name || "Amethyst"}
        houseName={"Amethyst"}
        onNext={onCoachMarkNext}
        targetSelector=".header-banner"
      />
      <CoachMarkStepThree
        visible={coachMarkStep === 3}
        onNext={onCoachMarkStepThreeNext}
      />
      <CoachMarkStepFour
        visible={coachMarkStep === 4}
        onNext={onCoachMarkStepFourNext}
      />
      <CoachMarkStepFive
        visible={coachMarkStep === 5}
        onNext={onCoachMarkStepFiveNext}
      />
      <CoachMarkStepSix
        visible={coachMarkStep === 6}
        onNext={onCoachMarkStepSixNext}
      />
      <CoachMarkStepSeven
        visible={coachMarkStep === 7}
        onNext={onCoachMarkStepSevenNext}
      />
      <CoachMarkStepEight
        visible={coachMarkStep === 8}
        onNext={onCoachMarkStepEightNext}
      />
      <CoachMarkStepNine
        visible={coachMarkStep === 9}
        onNext={onCoachMarkStepNineNext}
      />
      {load ? (
        <div className="flex items-center justify-center h-screen mb-5">
          <img width="100px" className="center" src={LoadImage} alt="loader" />
        </div>
      ) : (
        <div className="relative flex flex-col pb-20">
          {/* <div className="absolute top-0 left-0 right-0 gradient-container "></div> */}
          <div className="absolute">
            <EmojiModal
              setVisible={(val) => {
                dispatch(setEmojiModal(val));
              }}
              visible={emojiModal}
            />
            <LeaderboardModal
              visible={leaderboardModalOpen}
              loading={leaderboardLoading}
              data={leaderboardData}
              onClose={() => setLeaderboardModalOpen(false)}
            />
            {userDetails?.houseMatches.length > 0 && (
              <PointsTrackerModal data={userDetails?.houseMatches} />
            )}
          </div>
          {/* {renderTopGradient()}
          {renderHeaderImages(userDetails)} */}
          <Header name={userDetails?.user?.name} stats={headerStats} />
          {/* <div className="text-center welcome-text mt-5">
            Welcome {userDetails?.user?.name}!
          </div> */}
          {userDetails?.challenges?.length === 0 && userDetails?.user?.houseId === null && (
            <div className="m-2 border-[3px] border-black rounded-lg">
              <img src={WelcomeImg} style={{ borderRadius: '0.5rem' }} alt="welcome image" />
            </div>
          )}
          {userDetails?.challenges?.length === 0 && userDetails?.user?.houseId !== null && (
            <div className="m-2 border-[3px] border-black rounded-lg">
              <img src={CompletedImg} style={{ borderRadius: '0.5rem' }} alt="completed challenge image" />
            </div>
          )}
          {challengeLoad ? (
            <div className="flex py-2 pl-3 mt-1 overflow-x-auto justify-center">
              <div
                className="flex justify-center py-4 bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${CrackerImg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "51% 22%",
                  backgroundSize: "76%",
                }}
              >
                <img
                  src={unicornImg}
                  alt="Your Image"
                  className="border-2 border-black rounded-lg w-50 h-60"
                />
              </div>
            </div>
          ) : (
            <div
              className="flex py-2 pl-3 mt-1 overflow-x-auto mx-auto"
              style={{ maxWidth: "46vh" }}
            >
              {userDetails?.challenges?.map((item: any, i: number) => {
                return <RenderChallenges key={`hc-${item?._id}-${i}`} challenge={item} index={i} />;
              })}
            </div>
          )}
          <div className="flex flex-row items-center px-3 pt-4 mb-2">
            
            {submit && (
              <div
                className="flex justify-end flex-1"
                onClick={() => {
                  setSubmit(false);
                }}
              >
                <img
                  src={require("../../assets/edit.png")}
                  alt=""
                  className="w-5 h-5 mr-1"
                />
              </div>
            )}
          </div>
          {!submit ? renderCheckInCard() : renderCheckInSaved()}
          {/* {userDetails} */}
          {userDetails?.house && (
            <div
              className={`flex flex-1 flex-row items-center coach-view-house-feed ${
                coachMarkStep === 6 ? "coach-view-house-feed-highlight" : ""
              }`}
            >
              <div className="inter-20-semi-bold ml-3 mt-5">
                {userDetails?.house?.name} House Feed{" "}
              </div>
              <span className="flex flex-row items-center mx-2 mt-4">
                <img
                  src={userDetails?.house?.image}
                  height="25"
                  width="25"
                  style={{ paddingTop: "3px" }}
                  alt="diamond"
                />
              </span>
            </div>
          )}
          {feeds?.map((item: any, i: number) => {
            // return <UserFeedard data={item} type={item?.challengeId?.type} />;
            return <Feeds key={item?._id} feedData={[item]} coachMarkStep={coachMarkStep} />;
          })}
          {/* <UserFeedard type="img" /> */}
          {/* <UserFeedard type="text" /> */}
          {/* {isOpen && <Modal isOpen={isOpen} onClose={handleClose} />} */}
        </div>
      )}
      {/* {readMoreModal ? (
        <div className="fixed max-w-80 min-h-auto bg-[#D9D9D9] p-4 flex justify-center items-center h-screen overflow-auto z-10">
          <div className="h-40 min-h-[480px]">
            <button
              className="absolute top-2 right-2 text-lg font-medium bg-white w-8 h-8 rounded-full"
              onClick={() => setReadMoreModal(false)}
            >
              x
            </button>
            <p className="text-sm font-medium text-black">More info: {info}</p>
          </div>
        </div>
      ) : (
        ""
      )} */}
      {readMoreModal ? (
        <div className="fixed !max-w-[430px] w-full min-h-auto flex items-center justify-center !bg-[#000000c4] !p-0 shadow-none !h-screen z-10 before:!hidden">
        <div className="fixed max-w-80 min-h-auto bg-[#D9D9D9] p-4 overflow-auto z-10 !h-40 min-h-[480px]">
            <button
              className="absolute top-2 right-2 text-lg font-medium bg-white w-8 h-8 rounded-full"
              onClick={() => setReadMoreModal(false)}
            >
              x
            </button>
            <p className="text-sm font-medium text-black">{info}</p>
          </div>
        </div>
      ) : (
        ""
      )}
      <AlertModal
        visible={showAlert}
        title="Oops!"
        message={alertMessage}
        onConfirm={() => setShowAlert(false)}
      />
    </>
  );
};

export default HomeScreen;
